import * as React from 'react'

const Spinner = () => {
  return (
    <div className="spinner-container">
        <div id="loading"></div>
    </div>
  )
}

export default Spinner